import styled from 'styled-components'

import { THEME, typeScale } from '../../styles'
import Ingredient from '../Ingredient'

const Styled = styled.div``
Styled.container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 1.6rem;
  width: 100%;

  &:last-child {
    padding-bottom: 0;
  }
`
Styled.involvedIngredients = styled.div`
  min-width: 4rem;
  margin-right: 1.6rem;
  position: relative;
  min-height: ${({ ingredientsCount }) =>
    ingredientsCount > 1
      ? `${4 + (ingredientsCount - 1) * (4 - 1.6)}rem`
      : '4rem'};
`
Styled.involvedIngredient = styled(Ingredient)`
  margin-bottom: -1.2rem;
  width: 4rem;
  height: 4rem;

  &:last-child {
    margin-bottom: 0;
  }
`
Styled.step = styled.div`
  flex: 1;
`
Styled.position = styled.p`
  ${typeScale('caption')};
  color: ${THEME.COLORS.foreground.secondary};
  text-align: left;
`
Styled.description = styled.p`
  color: ${THEME.COLORS.foreground.primary};
  text-align: left;
  white-space: pre-wrap;
`

export default Styled
